<template>
  <!-- eslint-disable max-len -->
  <div
    :class="['main-view', { 'mobile': $isMobile}]"
  >
    <Header
      v-if="$isMobile"
      ref="header"
      class="main-view__header"
    />
    <WaveSelector
      v-if="$debug === 'true'"
      class="main-view__wave-selector"
    />
    <transition name="fade">
      <router-view ref="body" />
    </transition>
    <Footer
      class="main-view__footer"
    />
  </div>
</template>

<script>
import Header from '@/components/common/header/Header.vue';
import Footer from '@/components/common/footer/Footer.vue';
import WaveSelector from '@/components/common/WaveSelector.vue';

export default {
  name: 'MainView',

  components: {
    Header,
    Footer,
    WaveSelector,
  },

  data() {
    return {
      state: 'released',
      bodyVisible: false,
      headerVisible: false,
    };
  },

  watch: {
    routeName(to, from) {
      this.updateHtmlClass(to, from);
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.updateHtmlClass(this.$routeName);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.updateHtmlClass(undefined, this.$routeName);
  },

  methods: {
    handleResize() {
      if (window.innerWidth <= parseInt(this.$tokens.bp_mobile, 0)) {
        this.$store.commit('setMobile', true);
      } else {
        this.$store.commit('setMobile', false);
      }
    },
    updateHtmlClass(newPage, oldPage = undefined) {
      const root = document.getElementsByTagName('html')[0];
      if (newPage) root.classList.add(`landing-${newPage}`);
      if (oldPage) root.classList.remove(`landing-${oldPage}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main-view {
  --padding: 0px;
  width: 100%;
  height: auto;
  // max-width: $container-width;
  max-width: 100%
  margin: 0 auto;
  background-color: $cl-blue;
  padding-top: var(--padding);
  &.mobile {
    --padding: 15px;

  }

  &__header {
    width: calc(100% - 10px);
    height: auto;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: var(--padding);
  }

  &__wave-selector {
    width: calc(100% - 20px);
    max-width: $container-width;
    margin: 0 auto;
    padding: 10px;
    display: flex;
    justify-content: center;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
